import * as localStorage from '@ms/yammer-libs-local-storage';

import CacheWithExpiration from './cacheWithExpiration';
import type { YammerCache } from './types';

const asyncLocalStorage: YammerCache = {
  getItem: async <T>(key: string) => localStorage.getItem<T>(key),
  setItem: async <T>(key: string, value: T) => {
    localStorage.setItem(key, value);
  },
  removeItem: async (key: string) => {
    localStorage.removeItem(key);
  },
  clear: async () => {
    localStorage.clear();
  },
};

export default class LocalStorageCache extends CacheWithExpiration {
  constructor(keyNamespace: string) {
    super(asyncLocalStorage, keyNamespace);
  }
}
